import {
    getFinancialList,
    fetchBackofficeFinancialRatesSite,
    registerNewRateSite,
    deleteRateSiteById,
    editFinancialRateSite,
    getEntityCompanyDropdown,
} from "../../api/backoffice";

import Vue from "vue";
import i18n from "@/i18n";
import store from "@/store";
//import { bus } from '@/utils/event-bus';

const hasInvalidValue = (v) => {
    if (v?.type === "dropdown") {
        let invalidValue = true;
        v.options?.map((option) => {
            if (option.selected) {
                invalidValue = option?.value == null || v.value === "-1";
            }
        });
        return invalidValue;
    }

    return v.value == null || v.value === "";
};


const getDefaultState = () => {
    return {
        // ******* Backoffice rate site details *************
        financialRateSiteBkoForm: {},
        financialRateSiteDetails: {},
        financialRateSiteDetailsDropdown: {
            companyGSCList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            entityCompanyList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 0,
                    text: i18n.t("-- Todas Empresas --"),
                },
                {
                    value: 0,
                    text: i18n.t("-- Todas Empresas PT --"),
                    disabled: true,
                },
                {
                    value: 0,
                    text: i18n.t("-- Todas Empresas ES --"),
                    disabled: true,
                }
            ],
            financialList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
        },
        containsChanges: false,
        // ******* Backoffice rate site list *************
        backofficeFinancialRatesSite: [],
        totalPages: 0,
        totalResults: 0,
        filters: {
            filter_search: "",
        },
        dropdownsFilters: {

        },
        isTableLoading: false,
    };
};

const state = getDefaultState();

const getters = {
    // ******* Backoffice rate site details *************
    getFinancialRateSiteBkoForm: (state) => state.financialRateSiteBkoForm,
    getFinancialRateSiteDetails: (state) => state.financialRateSiteDetails,

    getCompanyGSCList: (state) => state.financialRateSiteDetailsDropdown.companyGSCList,
    getEntityCompanyList: (state) => state.financialRateSiteDetailsDropdown.entityCompanyList,
    getFinancialList: (state) => state.financialRateSiteDetailsDropdown.financialList,
    getContainsChanges: (state) => state.containsChanges,
    // ******* Backoffice rate site list *************
    getBackofficeFinancialRatesSite: (state) => state.backofficeFinancialRatesSite,
    getFinancialRatesSiteTotalPages: (state) => state.totalPages,
    getFinancialRatesSiteTotalResults: (state) => state.totalResults,
    getFinancialRatesSiteFilledFilters: (state) =>
        Object.fromEntries(
            Object.entries(state.filters).filter(([, v]) => {
                return v != "";
            })
        ),
    getFinancialRatesSiteFilterByKey: (state) => (key) => state.filters[key],
    getDropdown: (state) => (key) => state.dropdownsFilters[key],
    isTableLoading: (state) => state.isTableLoading,
};

const mutations = {
    // ******* Backoffice rate site details *************
    setFinancialRateSiteBkoForm(state, financialRateSiteBkoForm) {
        state.financialRateSiteBkoForm = financialRateSiteBkoForm;
    },
    setFinancialRateSiteDetails(state, financialRateSiteDetails) {
        state.setFinancialRateSiteDetails = financialRateSiteDetails;
    },
    resetFinancialRateSiteDetailsDropdownsState(state) {
        state.financialRateSiteDetailsDropdown = getDefaultState().financialRateSiteDetailsDropdown;
    },
    setCompanyGSCSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            return { value: item["id"], text: item["name"] };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setEntityCompanySimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {

        const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
        const countryCode = idInstance == 1 ? "PT" : idInstance == 2 ? "ES" : "";

        const textTodasEmpresas = i18n.t(`${"-- Todas Empresas " + countryCode + " --"}`);
        const textPT = i18n.t("-- Todas Empresas PT --");
        const textES = i18n.t("-- Todas Empresas ES --");

        let dropdownNeoObj = data?.map((item) => {
            if (item["STATUS"] == "N") {
                return { value: item["ID"], text: item["NAME"], disabled: true, };
            } else {
                return { value: item["ID"], text: item["NAME"] };
            }
        }) || [];

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: 0,
                text: textTodasEmpresas,
            },
            {
                value: 0,
                text: textPT,
                disabled: true,
            },
            {
                value: 0,
                text: textES,
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFinancialSimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        let dropdownNeoObj = data?.map((item) => {
            if(item["STATUS"] == "N") {
                return { value: item["ID"], text: item["NAME"], disabled: true, };
            } else {
                return { value: item["ID"], text: item["NAME"] };
            }
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setFieldValue(state, { key, value, options }) {
        console.log(options);

        state?.financialRateSiteBkoForm?.form?.forEach((form) => {
            let field = form.fields.find((f) => f.key === key);

            if (field && value && field.type !== "dropdown") {
                field.value = value;

                field.hasError = false;
            }
            if (field && value && field.type === "dropdown") {
                field.hasError = false;
            }
        });
    },
    setIncrementField(state, { key }) {
        state?.financialRateSiteBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setFieldAttribute(state, { key, attribute, value }) {

        state?.financialRateSiteBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);

            if (field) {
                if (!(field.key?.startsWith("idFinancial") || field.key?.startsWith("idGscCompany"))) {
                    let dropdownNeoObj = value.map((item) => {
                        return { value: item["id"], text: item["name"] };
                    });

                    dropdownNeoObj = [
                        {
                            value: -1,
                            text: i18n.t("dropdownSelection"),
                            disabled: true,
                        },
                        ...dropdownNeoObj,
                    ];
                    field[attribute] = dropdownNeoObj;
                } else {
                    field[attribute] = value;
                }

            }
        });
    },
    setContainsChanges(state, containsChanges) {
        state.containsChanges = containsChanges;
    },
    // ******* Backoffice rates site list *************
    setBackofficeFinancialRatesSite(state, backofficeFinancialRatesSite) {
        backofficeFinancialRatesSite = backofficeFinancialRatesSite.map((rate) => {
            return {
                ...rate,
                disabled: true,
                hasError: false
            }
        });
        state.backofficeFinancialRatesSite = backofficeFinancialRatesSite;
    },
    setRatesTable(state, backofficeFinancialRatesSite) {
        state.backofficeFinancialRatesSite = backofficeFinancialRatesSite;
    },
    setFinancialRatesSiteTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setFinancialRatesSiteTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setFinancialRateOfSiteFilters(state, financialRatesSiteFilters) {
        state.financialRatesSiteFilters = financialRatesSiteFilters;
    },
    setMixedDropdownValues(
        state,
        {
            data,
            stateType = "dropdownsFilters",
            type,
            valueKey = "ID",
        }
    ) {
        let dropdownNeoObj = data.map((item) => {
            return {
                value: item?.[valueKey],
                text: item?.NAME,
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFilterByKey(state, filter) {
        state.filters[filter.key] = filter.value;
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
};

const actions = {
    // ******* Backoffice rate site details *************
    async getFinancialRateSiteDetails({ commit }, idRateSite) {
        console.log(idRateSite);
        try {
            const response = {};//await fetchCompanyDetailsById(idRateSite);

            commit("setCompanyDetails", response?.data?.data);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async checkIfFormIsValid({ commit }) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.financialRateSiteBkoForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", { field: i18n.t(label) })}</li>`;
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    // ******* Backoffice rates site list *************
    async getBackofficeFinancialRatesSite({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBackofficeFinancialRatesSite(
                page.page,
                page.orderBy,
                page?.search,
                page?.pageSize,
                idInstance
            );
            commit("setBackofficeFinancialRatesSite", response?.data?.data);
            commit("setFinancialRatesSiteTotalPages", response?.data?.pages);
            commit("setFinancialRatesSiteTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async getEntityCompanyList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityCompanyDropdown(idInstance);
            const entityCompany = response?.data?.data;
            commit("setEntityCompanySimpleList", {
                data: entityCompany,
                stateType: "financialRateSiteDetailsDropdown",
                type: "entityCompanyList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getFinancialList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getFinancialList(idInstance);
            const financialList = response?.data?.data;
            commit("setFinancialSimpleList", {
                data: financialList,
                stateType: "financialRateSiteDetailsDropdown",
                type: "financialList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async dateteFinancialRateSite({ commit }, { idFinancialRatesSite, idFinancial }) {
        commit("setTableLoading", false);
        try {
            const response = await deleteRateSiteById(idFinancialRatesSite, idFinancial);
            return response?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async editFinancialRateSite({ commit }, { rateSiteId, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await editFinancialRateSite(rateSiteId, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async addFinancialRateSite({ commit }, payload) {
        commit("setTableLoading", false);
        try {
            const response = await registerNewRateSite(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
